"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Wrapper object for MetaField which keep more info about field advancedFilters.
 */
var /**
 * Wrapper object for MetaField which keep more info about field advancedFilters.
 */
MetaFieldWrapper = /** @class */ (function () {
    function MetaFieldWrapper(metaField, categorySystemName, path, isParentFilter, fieldSystemNameInParentCategory, sortId) {
        this._metaField = metaField;
        this._categorySystemName = categorySystemName;
        this._path = path;
        this._isParentFilter = isParentFilter;
        this._fieldSystemNameInParentCategory = fieldSystemNameInParentCategory;
        this._sortId = sortId;
    }
    Object.defineProperty(MetaFieldWrapper.prototype, "metaField", {
        get: function () {
            return this._metaField;
        },
        set: function (value) {
            this._metaField = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MetaFieldWrapper.prototype, "categorySystemName", {
        get: function () {
            return this._categorySystemName;
        },
        set: function (value) {
            this._categorySystemName = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MetaFieldWrapper.prototype, "path", {
        get: function () {
            return this._path;
        },
        set: function (value) {
            this._path = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MetaFieldWrapper.prototype, "isParentFilter", {
        get: function () {
            return this._isParentFilter;
        },
        set: function (value) {
            this._isParentFilter = value;
        },
        enumerable: true,
        configurable: true
    });
    MetaFieldWrapper.prototype.getPathAsMappingKey = function () {
        return this.categorySystemName + "." + this.path;
    };
    Object.defineProperty(MetaFieldWrapper.prototype, "sortId", {
        get: function () {
            return this._sortId;
        },
        set: function (value) {
            this._sortId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MetaFieldWrapper.prototype, "fieldSystemNameInParentCategory", {
        get: function () {
            return this._fieldSystemNameInParentCategory;
        },
        set: function (value) {
            this._fieldSystemNameInParentCategory = value;
        },
        enumerable: true,
        configurable: true
    });
    return MetaFieldWrapper;
}());
exports.MetaFieldWrapper = MetaFieldWrapper;
//# sourceMappingURL=metafield.wrapper.js.map